import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { clientApi, useClientAuth } from "@/context/ClientAuth";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useClientAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : "";
    const run = async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const res = await clientApi.post("/client/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        localStorage.setItem("client_token", res.data.session_token);
        setUser(res.data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: res.data.user } });
      } catch {
        navigate("/login?error=1");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-[#041C3E] text-white">
      <div className="flex items-center gap-3">
        <Loader2 className="animate-spin" size={22} /> Signing you in…
      </div>
    </div>
  );
};
